namespace $ {

	export type $shm_projects_changes_group = {
		project: string
		changes: readonly string[]
	}

	export function $shm_projects_changes_format( groups: readonly $shm_projects_changes_group[] ) {
		const grouped = new Map< string, string[] >()
		for( const group of groups ) {
			const project = String( group?.project || '' ).trim()
			const changes = Array.isArray( group?.changes ) ? group.changes
				.map( change => String( change ).trim().replace( /^(?:[-*]\s+|\d+[.)]\s*)/, '' ) )
				.filter( Boolean ) : []
			if( !project || !changes.length ) continue
			grouped.set( project, [ ...( grouped.get( project ) ?? [] ), ...changes ] )
		}
		return [ ...grouped ].map( ( [ project, changes ] )=>
			`**${ project }:**\n\n${ changes.map( ( change, index )=> `${ index + 1 }. ${ change }` ).join( '\n' ) }`
		).join( '\n\n' )
	}

}
